
import { Injectable, OnInit } from "@angular/core";

/**
 * Classe responsável pela validação e formatação de CPF.
 * Baseado no projeto: https://github.com/tiagoporto/gerador-validador-cpf
 */
@Injectable()
export class AgroCPFUtils implements OnInit {

    ngOnInit(): void { }

    /**
     * Function responsável pela Validação CPF
     * @param cpf 
     */
    public validate(cpf: string): Boolean {
        if (cpf == null) {
            return false;
        }
        cpf = cpf.replace(/\.|-|\s/g, '');

        if (cpf.length != 11) {
            return false;
        }
        if ((cpf == '00000000000') || (cpf == '11111111111') || (cpf == '22222222222') || (cpf == '33333333333') || (cpf == '44444444444') || (cpf == '55555555555') || (cpf == '66666666666') || (cpf == '77777777777') || (cpf == '88888888888') || (cpf == '99999999999')) {
            return false;
        }
        let numero: number = 0;
        let caracter: string = '';
        let numeros: string = '0123456789';
        let j: number = 10;
        let somatorio: number = 0;
        let resto: number = 0;
        let digito1: number = 0;
        let digito2: number = 0;
        let cpfAux: string = '';
        cpfAux = cpf.substring(0, 9);
        for (let i: number = 0; i < 9; i++) {
            caracter = cpfAux.charAt(i);
            if (numeros.search(caracter) == -1) {
                return false;
            }
            numero = Number(caracter);
            somatorio = somatorio + (numero * j);
            j--;
        }
        resto = somatorio % 11;
        digito1 = 11 - resto;
        if (digito1 > 9) {
            digito1 = 0;
        }
        j = 11;
        somatorio = 0;
        cpfAux = cpfAux + digito1;
        for (let i: number = 0; i < 10; i++) {
            caracter = cpfAux.charAt(i);
            numero = Number(caracter);
            somatorio = somatorio + (numero * j);
            j--;
        }
        resto = somatorio % 11;
        digito2 = 11 - resto;
        if (digito2 > 9) {
            digito2 = 0;
        }
        cpfAux = cpfAux + digito2;
        if (cpf != cpfAux) {
            return false;
        }
        else {
            return true;
        }
    };

    /**
     * Formatação do CPF
     * @param value 
     * @param formatter 
     */
    private formatCPF(value: string) {
        let digitsSeparator = '.';
        let checkersSeparator = '-';

        if (value.length > 11) {
            return;
        } else if (value.length < 11) {
            return;
        } else {
            return value.slice(0, 3) + digitsSeparator + value.slice(3, 6) + digitsSeparator + value.slice(6, 9) + checkersSeparator + value.slice(9, 11);
        }
    };

    /**
     * Function responsável em formatar o CPF.
     * @param cpf 
     */
    public format(cpf: string) {
        if (!cpf) {
            return;
        }

        let getCPF = cpf.replace(/[^\d]/g, '');

        return this.formatCPF(getCPF);
    };
}